import React, { useState, useEffect } from "react";

import {
  LayoutDashboard,
  Users,
  Receipt,
  Wallet,
  Package2,
  BarChart3,
  Gift,
  Star,
  ShipWheel,
  Landmark,
  ShieldCheck,
  LogOut,
} from "lucide-react";

import { Link, useLocation } from "react-router-dom";

import "../css/header.css";

const HeaderNav = () => {

  const location = useLocation();

  const [dateTime, setDateTime] =
    useState("");

  /* ========================================================
      LIVE DATE/TIME
  ======================================================== */
  useEffect(() => {

    const update = () => {

      setDateTime(
        new Date().toLocaleString(
          "en-US",
          {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          }
        )
      );
    };

    update();

    const interval =
      setInterval(update, 1000);

    return () =>
      clearInterval(interval);

  }, []);

  /* ========================================================
      LOGOUT
  ======================================================== */
  const handleLogout = () => {

    localStorage.removeItem(
      "rcs_pos_auth"
    );

    sessionStorage.clear();

    window.location.href = "/login";
  };

  /* ========================================================
      NAV LINKS
  ======================================================== */
  const navItems = [
    {
      path: "/",
      label: "Dashboard",
      icon: LayoutDashboard,
    },

    {
      path: "/customers",
      label: "Customers",
      icon: Users,
    },

    {
      path: "/sales-history",
      label: "Sales",
      icon: Receipt,
    },

    {
      path: "/balances",
      label: "Balances",
      icon: Wallet,
    },

    {
      path: "/products",
      label: "Products",
      icon: Package2,
    },

    {
      path: "/reports",
      label: "Reports",
      icon: BarChart3,
    },

    {
      path: "/promotions",
      label: "Promotions",
      icon: Gift,
    },

    {
      path: "/loyalty",
      label: "Loyalty",
      icon: Star,
    },

    {
      path: "/ferrypass",
      label: "Ferry",
      icon: ShipWheel,
    },

    {
      path: "/cash-statement",
      label: "Cash",
      icon: Landmark,
    },

    {
      path: "/admin/users",
      label: "Users",
      icon: ShieldCheck,
    },
  ];

  return (
    <header className="modern-header">

      {/* ====================================================
          LEFT
      ==================================================== */}
      <div className="modern-header-left">

        <div className="modern-header-logo">

          <div className="modern-header-logo-icon">
            R
          </div>

          <div className="modern-header-logo-text">

            <h1>RCS POS</h1>

            <span>
              All Inclusive
            </span>

          </div>

        </div>

        <div className="modern-header-time">
          {dateTime}
        </div>

      </div>

      {/* ====================================================
          NAV
      ==================================================== */}
      <nav className="modern-header-nav">

        {navItems.map((item) => {

          const Icon = item.icon;

          const active =
            location.pathname ===
              item.path ||
            location.pathname.startsWith(
              item.path
            );

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`modern-nav-link ${
                active
                  ? "active"
                  : ""
              }`}
            >

              <Icon
                size={15}
                strokeWidth={2.3}
              />

              <span>
                {item.label}
              </span>

            </Link>
          );
        })}

      </nav>

      {/* ====================================================
          RIGHT
      ==================================================== */}
      <div className="modern-header-right">

        <button
          className="modern-logout-btn"
          onClick={handleLogout}
        >

          <LogOut
            size={16}
            strokeWidth={2.3}
          />

          <span>Logout</span>

        </button>

      </div>

    </header>
  );
};

export default HeaderNav;